/**
 * Turnstile Spin — client-side siteverify via the managed Cloudflare Worker.
 * Mirror of apps/web/src/lib/turnstile-siteverify.ts for the landing app.
 */

export type TurnstileSiteverifyResult = {
  success: boolean;
  error?: string;
};

export type TurnstileSiteverifyOpts = {
  fetch?: typeof fetch;
};

function getSiteverifyUrl(): string {
  return (
    (import.meta as unknown as { env?: Record<string, string> }).env
      ?.VITE_TURNSTILE_SITEVERIFY_URL ?? ""
  );
}

function getSiteKey(): string {
  return (
    (import.meta as unknown as { env?: Record<string, string> }).env
      ?.VITE_TURNSTILE_SITE_KEY ?? ""
  );
}

export async function verifyTurnstileViaWorker(
  token: string,
  opts: TurnstileSiteverifyOpts = {},
): Promise<TurnstileSiteverifyResult> {
  const workerUrl = getSiteverifyUrl();
  const siteKey = getSiteKey();

  if (!workerUrl || !siteKey) {
    return { success: true };
  }

  if (typeof token !== "string" || token.length === 0) {
    return { success: false, error: "empty_token" };
  }

  const doFetch = opts.fetch ?? fetch;
  try {
    const res = await doFetch(workerUrl, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ token }),
    });
    if (!res.ok) {
      return { success: false, error: `worker_http_${res.status}` };
    }
    const data = (await res.json()) as { success?: boolean };
    if (data.success === true) return { success: true };
    return { success: false, error: "verify_failed" };
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    return { success: false, error: msg };
  }
}
